import React from 'react'
import { MDXTag } from '@mdx-js/tag'


import DefaultLayout from "/var/lib/jenkins/jobs/app-styleguide/workspace/src/templates/page.js"
import { FeedbackCapture } from 'module-tsl-ui-feedback-capture';
import { Button } from 'module-tsl-ui-elements';
import WithDocgen from 'module-tsl-ui-feedback-capture/with-docs/FeedbackCapture';
import pkg from 'module-tsl-ui-feedback-capture/package.json';
import PropsTable from '../../../components/propsTable';
import Version from '../../../components/version';
import LiveCode from '../../../components/liveCode';

const layoutProps = {
  
};
export default class MDXContent extends React.Component {
  constructor(props) {
    super(props)
    this.layout = DefaultLayout
  }
  render() {
    const { components, ...props } = this.props

    return <MDXTag
             name="wrapper"
             Layout={this.layout} layoutProps={Object.assign({}, layoutProps, props)}
             components={components}>


<MDXTag name="h3" components={components} props={{"id":"example-editable"}}><MDXTag name="a" components={components} parentName="h3" props={{"href":"#example-editable","aria-label":"example editable permalink","class":"anchor"}}></MDXTag>{`example (editable)`}</MDXTag>
<LiveCode
  code={`<FeedbackCapture onSendFeedback={() => console.log('Send')} />`}
  scope={ { FeedbackCapture, Button } }
/>
<PropsTable data={WithDocgen.__docgenInfo} />
<Version name={'npm i module-tsl-ui-feedback-capture --save'} version={pkg.version} />
           </MDXTag>
  }
}

export const _frontmatter = {};

  